var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isUsuarioExterno && _vm.exibeObs
        ? _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c("app-header-dados-processo", {
                attrs: {
                  showBotaoOpcoesHeader: false,
                  processo: _vm.processo,
                  isCCR: _vm.isCCR,
                  dadosCadastros: _vm.dadosCadastros
                }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.isGerenciar
        ? _c("confirmar-dados", {
            attrs: {
              dadosVtn: _vm.dadosVtn,
              isVisualizar: _vm.isVisualizar,
              processo: _vm.processo,
              exibeCardObs: _vm.exibeObs
            }
          })
        : _vm._e(),
      !_vm.isGerenciar && _vm.escolheuExterno && !_vm.isCriado
        ? _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c(
                "div",
                { staticClass: "cardHeader" },
                [
                  _c("b", [_vm._v("Formas de pagamento:")]),
                  !_vm.isAVista
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.openModal }
                        },
                        [_vm._v("Tabela de amortização")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("div", { attrs: { id: "line" } }),
              _c(
                "div",
                { staticClass: "centerRadio" },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "radio-group",
                      attrs: {
                        disabled: !_vm.isUsuarioExterno || _vm.isVisualizar,
                        name: "Cônjuge possui certidão?"
                      },
                      model: {
                        value: _vm.dadosVtn.formaPagamento,
                        callback: function($$v) {
                          _vm.$set(_vm.dadosVtn, "formaPagamento", $$v)
                        },
                        expression: "dadosVtn.formaPagamento"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: "PARCELADO" } },
                        [_vm._v("Pagamento parcelado")]
                      ),
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: "A_VISTA" } },
                        [_vm._v("Pagamento à vista")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "flexStart" }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("span", [_vm._v("Período de carência (PC):")]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          disabled:
                            !_vm.isUsuarioExterno ||
                            _vm.isVisualizar ||
                            _vm.isAVista,
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        on: {
                          change: function($event) {
                            _vm.changeCarencia && _vm.calcular(false)
                          }
                        },
                        model: {
                          value: _vm.dadosVtn.carencia,
                          callback: function($$v) {
                            _vm.$set(_vm.dadosVtn, "carencia", $$v)
                          },
                          expression: "dadosVtn.carencia"
                        }
                      },
                      _vm._l(_vm.carencias, function(carencia) {
                        return _c("el-option", {
                          key: carencia.id,
                          attrs: { label: carencia.value, value: carencia.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("span", [_vm._v("Nº de parcelas anuais (n):")]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          disabled:
                            !_vm.isUsuarioExterno ||
                            _vm.isVisualizar ||
                            _vm.isAVista,
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        on: {
                          change: function($event) {
                            return _vm.calcular(false)
                          }
                        },
                        model: {
                          value: _vm.dadosVtn.qntdParcelas,
                          callback: function($$v) {
                            _vm.$set(_vm.dadosVtn, "qntdParcelas", $$v)
                          },
                          expression: "dadosVtn.qntdParcelas"
                        }
                      },
                      _vm._l(_vm.parcelasComputed, function(parcela) {
                        return _c("el-option", {
                          key: parcela.id,
                          attrs: { label: parcela.value, value: parcela.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm.isEstadoAP
                ? _c(
                    "div",
                    { staticClass: "flex margin10" },
                    [
                      _c(
                        "el-col",
                        { staticClass: "flex", attrs: { span: 9 } },
                        [
                          _c("app-display", {
                            attrs: {
                              label: "Resumo",
                              content: " ",
                              contentAlignRight: false
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "flex", attrs: { span: 8 } },
                        [
                          _c("app-display", {
                            attrs: {
                              label: "Valor(R$)",
                              content: " ",
                              contentAlignRight: false
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "flex", attrs: { span: 7 } },
                        [
                          _c("app-display", {
                            attrs: {
                              label: "Data vencimento",
                              content: " ",
                              contentAlignRight: false
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.dadosAmortizacaoComputed, function(parcela) {
                return _c(
                  "div",
                  { staticClass: "flex margin10" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "flex", attrs: { span: 9 } },
                      [
                        _c("app-display", {
                          staticClass: "espacamento",
                          attrs: {
                            content: _vm.getLabel(parcela),
                            contentAlignRight: false
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { staticClass: "flex", attrs: { span: 8 } },
                      [
                        _c("app-display", {
                          staticClass: "espacamento",
                          attrs: {
                            content: parcela.valorFormatado,
                            contentAlignRight: false
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { staticClass: "flex", attrs: { span: 7 } },
                      [
                        _c("app-display", {
                          staticClass: "espacamento",
                          attrs: {
                            content: parcela.dataVencimentoFormatada,
                            contentAlignRight: false
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm.escolheuExterno && !_vm.isCriado
        ? _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c("app-divider", {
                staticClass: "margin-top",
                attrs: {
                  label: "Detalhamento da dívida: ",
                  addMarginTop: false
                }
              }),
              _c("p", { staticStyle: { color: "red", "font-size": "13px" } }, [
                _vm._v(
                  "Em caso de pagamento à vista, observar o Valor Final do Imóvel (VFI)."
                )
              ]),
              _c(
                "div",
                { staticClass: "centerRadio" },
                [
                  _c(
                    "el-col",
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Tipo de pagamento:",
                          content: _vm.formaPagamentoComputed,
                          contentAlignRight: true,
                          blackLabel: true
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Quantidade de DARs emitidos:",
                          content: _vm.dadosVtn.qtdDarsEmitidos,
                          contentAlignRight: true,
                          blackLabel: true
                        }
                      }),
                      !_vm.isUsuarioExterno
                        ? _c("app-display", {
                            attrs: {
                              label: "Situação da VTN:",
                              content: _vm.dadosDetalhamento.situacaoVtn,
                              contentAlignRight: true,
                              blackLabel: true
                            }
                          })
                        : _vm._e(),
                      _c("app-display", {
                        attrs: {
                          label: "Valor Final do Imóvel (VFI):",
                          content: _vm.formataMoeda(
                            _vm.dadosVtn.valorFinalImovel
                          ),
                          contentAlignRight: true,
                          blackLabel: true
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Prazo de pagamento (PP):",
                          content: null,
                          contentAlignRight: true,
                          blackLabel: true
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Período de carência (PC):",
                          content: _vm.dadosVtn.carencia + " ano(s)",
                          contentAlignRight: true,
                          blackLabel: true
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Nº de parcelas anuais:",
                          content: _vm.dadosVtn.qntdParcelas + " parcela(s) ",
                          contentAlignRight: true,
                          blackLabel: true
                        }
                      }),
                      !_vm.isEstadoAP
                        ? _c("app-display", {
                            attrs: {
                              label: "Data inicial (Dti):",
                              content: _vm.dadosVtn.dataInicialFormatada,
                              contentAlignRight: true,
                              blackLabel: true
                            }
                          })
                        : _vm._e(),
                      _vm.isEstadoAP
                        ? _c("app-display", {
                            attrs: {
                              label: "Data inicial (Dti):",
                              content: _vm.dadosVtn.dataCriacaoFormatada,
                              contentAlignRight: true,
                              blackLabel: true
                            }
                          })
                        : _vm._e(),
                      _c("app-display", {
                        attrs: {
                          label: "Data final (Dtf):",
                          content: _vm.dadosDetalhamento.dataFinal || "-",
                          contentAlignRight: true,
                          blackLabel: true
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Taxa de juros anual (i):",
                          content: _vm.dadosVtn.taxaJurosFormatada,
                          contentAlignRight: true,
                          blackLabel: true
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Próximo vencimento:",
                          content: _vm.dadosVtn.qtdDarsEmitidos,
                          contentAlignRight: true,
                          blackLabel: true
                        }
                      }),
                      !_vm.isUsuarioExterno
                        ? _c("app-display", {
                            attrs: {
                              label: "Total pago:",
                              content: "R$ " + _vm.dadosDetalhamento.totalPago,
                              contentAlignRight: true,
                              blackLabel: true
                            }
                          })
                        : _vm._e(),
                      !_vm.isUsuarioExterno
                        ? _c("app-display", {
                            attrs: {
                              label: "Saldo devedor (DV):",
                              content: "" + _vm.dadosDetalhamento.saldoDevedor,
                              contentAlignRight: true,
                              blackLabel: true
                            }
                          })
                        : _vm._e(),
                      _c("app-display", {
                        attrs: {
                          label: "Valor Final do Imóvel (VFI) após carência:",
                          content:
                            _vm.dadosDetalhamento
                              .valorFinalAposCarenciaFormatado,
                          contentAlignRight: true,
                          blackLabel: true
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Total de juros:",
                          content: _vm.formataMoeda(
                            _vm.dadosDetalhamento.totalJuros
                          ),
                          contentAlignRight: true,
                          blackLabel: true
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Total de correção anual:",
                          content: _vm.formataMoeda(
                            _vm.dadosDetalhamento.correcaoAnual
                          ),
                          contentAlignRight: true,
                          blackLabel: true
                        }
                      }),
                      !_vm.isUsuarioExterno
                        ? _c("app-display", {
                            attrs: {
                              label: "Valor inicial da prestação (PMT):",
                              content: _vm.dadosDetalhamento.prestacaoInicial,
                              contentAlignRight: true,
                              blackLabel: true
                            }
                          })
                        : _vm._e(),
                      _c("app-display", {
                        attrs: {
                          label: "Total a pagar no final:",
                          content: _vm.dadosDetalhamento.totalNoFinal
                            ? _vm.formataMoeda(
                                _vm.dadosDetalhamento.totalNoFinal
                              )
                            : "-",
                          contentAlignRight: true,
                          blackLabel: true
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isGerenciar
        ? _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c("tabela-amortizacao", {
                attrs: {
                  dados: _vm.dadosAmortizacao,
                  isVisualizar: false,
                  processo: _vm.processo,
                  disableCheck: []
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.isUsuarioExterno
        ? _c("app-buttons-cadastro", {
            attrs: {
              showButtonSalvar: false,
              showButtonCancelar: !_vm.isResumo,
              showButtonFinalizar: !_vm.isResumo,
              isUltimoPasso: true,
              isPrimeiroPasso: !_vm.isResumo,
              isIntroPasso: false
            },
            on: {
              cancelar: _vm.cancelar,
              finalizar: _vm.finalizar,
              voltar: _vm.cancelar
            }
          })
        : _vm._e(),
      _vm.showModal
        ? _c(
            "app-modal",
            {
              attrs: {
                closeOutside: false,
                titulo: "Tabela de amortização",
                width: 1000
              },
              on: {
                closeModal: function($event) {
                  return _vm.closeModal()
                }
              }
            },
            [
              _c(
                "template",
                { slot: "body" },
                [
                  _c("tabela-amortizacao", {
                    attrs: { dados: _vm.dadosAmortizacao }
                  })
                ],
                1
              )
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa54701c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa54701c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/VisualizarVtn.vue
// module id = null
// module chunks = 